import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/productBookingFields', request)
}

export {get}
